import { h } from 'preact';
import * as BaseComp from 'components/bolt/landscapeOverlay/landscapeOverlay.js';
import Store from 'store/store';
import { RotatePhone } from 'helpers/svgs';
import s from 'components/bolt/landscapeOverlay/landscapeOverlay.sss';

export default class LandscapeOverlay extends BaseComp.default {
	render() {
		const store = Store.get();
		const copy = store?.appData?.copy?.baseCopy || {};
		return (
			<div className={s.wrapper}>
				<RotatePhone class={s.phoneIcon} ariaLabel="Phone Icon" />
				{copy.$NO_SUPPORT_ROTATE_MSG && <p>{copy.$NO_SUPPORT_ROTATE_MSG}</p>}
			</div>
		);
	}
}
